import validator from "validator";
import { regex } from '../../../../const/nuclias/regex';

const defaultMyProfileState = {
  name: {
    value: '',
    isDirty: false,
    isValid: false,
  },
  email: null,
  currentPassword: {
    value: '',
    isDirty: false,
    isValid: true,
    isText: true,
    isFocus: false
  },
  newPassword: {
    value: '',
    isDirty: false,
    isValid: true,
    isText: true,
    isFocus: false,
    checkSame: false
  },
  confirmPassword: {
    value: '',
    isDirty: false,
    isValid: true,
    isText: true,
    isFocus: false,
    checkSame: false
  },
  deletePassword: {
    value: '',
    isDirty: false,
    isValid: false,
    isText: true,
  },
  selectedTwoFaType: null,
  idleTimeout: 60,
  loginPreference: {},
  photo: {
    file: null,
    photoS3Path: null,
    photoSource: null,
    uploadPhotoStep: 0
  },
  optInMarketingEmail: false,
  originalWebSetting: {},
  code: '',
  googleDOM: {
    qrcodeGened: false,
    showWarning: true,
    twoFASelected: true,
    labelStr: '',
    issuerStr: '',
    secretStr: '',
    code: '',
    success: false,
    successMsg: null,
    errorMsg: null
  }
};


const myProfileAction = {
  setData: 'SET_DATA',
  changeName: 'CHANAGE_NAME',
  changeCurrentPassword: 'CHANGE_CURRENT_PASSWORD',
  toggleCurrentPasswordEye: 'TOGGLE_CURRENT_PASSWORD_EYE',
  changeNewPassword: 'CHANGE_NEW_PASSWORD',
  toggleNewPasswordEye: 'TOGGLE_NEW_PASSWORD_EYE',
  changeConfirmPassword: 'CHANGE_CONFIRM_PASSWORD',
  toggleConfirmPasswordEye: 'TOGGLE_CONFIRM_PASSWORD_EYE',
  changeTwoFactor: 'CHANGE_TWO_FACTOR',
  changeLogoutTime: 'CHANGE_LOGOUT_TIME',
  changeLoginPreference: 'CHANGE_LOGIN_PREFERENCE',
  clickOptInMarketingEmail: 'CLICK_OPT_IN_MARKETING_EMAIL',
  setCode: 'SET_CODE',
  setQRData: 'SET_QR_DATA',
  changeNewPasswordFocus: 'CHANGE_NEW_PASSWORD_FOCUS',
  changeNewPasswordBlur: 'CHANGE_NEW_PASSWORD_BLUR',
  changeConfirmPasswordFocus: 'CHANGE_CONFIRM_PASSWORD_FOCUS',
  changeConfirmPasswordBlur: 'CHANGE_CONFIRM_PASSWORD_BLUR',
  uploadFile: 'UPLOAD_FILE',
  deleteImage: 'DELETE_IMAGE',
  changeDeletePassword: ' CHANGE_DELETE_PASSWORD',
  toggleDeletePasswordEye: 'TOGGLE_DELETE_PASSWORD_EYE',
  initPassword: 'INIT_PASSWORD',
}

const myProfileReducer = (state, action) => {
  switch (action.type) {
    case myProfileAction.setData:
      return {
        ...state,
        name: {
          ...state.name,
          value: action.payload.name,
          isDirty: true,
          isValid: validator.isByteLength(action.payload.name, { max: 64 })
        },
        email: action.payload.email,
        idleTimeout: (action.payload.webSetting && action.payload.webSetting.others.idle_timeout) ? action.payload.webSetting.others.idle_timeout : 60,
        optInMarketingEmail: action.payload.optInMarketingEmail,
        originalWebSetting: action.payload.webSetting,
        photo: {
          ...state.photo,
          file: null,
          photoSource: null,
          uploadPhotoStep: 0,
          photoS3Path: action.payload.profilePhotoS3Path
        }
      };
    case myProfileAction.changeName:
      return {
        ...state,
        name: {
          ...state.name,
          value: action.payload,
          isDirty: true,
          isValid: validator.isByteLength(action.payload, { min: 1, max: 64 })
        }
      };
    case myProfileAction.changeCurrentPassword:
      return {
        ...state,
        currentPassword: {
          ...state.currentPassword,
          value: action.payload,
          isDirty: true,
          isValid: validator.matches(action.payload, regex.password) || action.payload === ""
        },
        newPassword: {
          ...state.newPassword,
          checkSame: action.payload === state.newPassword.value ? true : false,
        }
      };
    case myProfileAction.changeNewPassword:
      return {
        ...state,
        newPassword: {
          ...state.newPassword,
          value: action.payload,
          isDirty: true,
          isValid: validator.matches(action.payload, regex.password) || action.payload === "",
          checkSame: state.currentPassword.value === action.payload ? true : false,
        }
      };
    case myProfileAction.changeNewPasswordFocus:
      return {
        ...state,
        newPassword: {
          ...state.newPassword,
          isFocus: true
        }
      };
    case myProfileAction.changeNewPasswordBlur:
      return {
        ...state,
        newPassword: {
          ...state.newPassword,
          isFocus: false
        }
      };
    case myProfileAction.changeConfirmPassword:
      return {
        ...state,
        confirmPassword: {
          ...state.confirmPassword,
          value: action.payload,
          isDirty: true,
          isValid: validator.matches(action.payload, regex.password) || action.payload === "",
          checkSame: state.newPassword.value === action.payload ? true : false,
        }
      };
    case myProfileAction.changeConfirmPasswordFocus:
      return {
        ...state,
        confirmPassword: {
          ...state.confirmPassword,
          isFocus: true
        }
      };
    case myProfileAction.changeConfirmPasswordBlur:
      return {
        ...state,
        confirmPassword: {
          ...state.confirmPassword,
          isFocus: false
        }
      };
    case myProfileAction.changeDeletePassword:
      return {
        ...state,
        deletePassword: {
          ...state.deletePassword,
          value: action.payload,
          isDirty: true,
          isValid: validator.matches(action.payload, regex.password)
        }
      };
    case myProfileAction.initPassword:
      return {
        ...state,
        currentPassword: {
          ...state.currentPassword,
          value: '',
          isDirty: false,
          isValid: true,
          isText: true,
          isFocus: false
        },
        newPassword: {
          ...state.newPassword,
          value: '',
          isDirty: false,
          isValid: true,
          isText: true,
          isFocus: false,
          checkSame: false
        },
        confirmPassword: {
          ...state.confirmPassword,
          value: '',
          isDirty: false,
          isValid: true,
          isText: true,
          isFocus: false,
          checkSame: false
        }
      };
    case myProfileAction.initDeletePassword:
      return {
        ...state,
        deletePassword: {
          ...state.deletePassword,
          value: '',
          isDirty: false,
          isValid: false,
          isText: true
        }
      };
    case myProfileAction.changeTwoFactor:
      return {
        ...state,
        selectedTwoFaType: action.payload
      };
    case myProfileAction.changeLogoutTime:
      return {
        ...state,
        idleTimeout: action.payload
      };
    case myProfileAction.changeLoginPreference:
      return {
        ...state,
        loginPreference: action.payload
      };
    case myProfileAction.clickOptInMarketingEmail:
      return {
        ...state,
        optInMarketingEmail: action.payload
      };
    case myProfileAction.toggleCurrentPasswordEye:
      return {
        ...state,
        currentPassword: {
          ...state.currentPassword,
          isText: !state.currentPassword.isText
        }
      };
    case myProfileAction.toggleNewPasswordEye:
      return {
        ...state,
        newPassword: {
          ...state.newPassword,
          isText: !state.newPassword.isText
        }
      };
    case myProfileAction.toggleConfirmPasswordEye:
      return {
        ...state,
        confirmPassword: {
          ...state.confirmPassword,
          isText: !state.confirmPassword.isText
        }
      };
    case myProfileAction.toggleDeletePasswordEye:
      return {
        ...state,
        deletePassword: {
          ...state.deletePassword,
          isText: !state.deletePassword.isText
        }
      };
    case myProfileAction.setCode:
      return {
        ...state,
        code: action.payload
      };
    case myProfileAction.setQRData:
      return {
        ...state,
        googleDOM: {
          ...state.googleDOM,
          issuerStr: action.payload.issuer,
          labelStr: action.payload.label,
          secretStr: action.payload.secret,
          qrcodeGened: true,
          qrCodeUrl: action.payload.qrCodeUrl
        }
      };
    case myProfileAction.uploadFile:
      return {
        ...state,
        photo: {
          ...state.photo,
          file: action.payload.file,
          photoSource: action.payload.event.target.result,
          uploadPhotoStep: 1
        }
      };
    case myProfileAction.deleteImage:
      return {
        ...state,
        photo: {
          ...state.photo,
          file: null,
          photoSource: null,
          photoS3Path: null,
          uploadPhotoStep: -1
        }
      };
    default:
      return defaultMyProfileState;
  }
};

export default {
  defaultState: defaultMyProfileState,
  action: myProfileAction,
  reducer: myProfileReducer
}